module.exports = __webpack_public_path__ + "img/487.fd0599c7.png";